import * as React from 'react';
import { AccordionTitle, ToggleButton, AccordionHeader, StyledAccordion } from './styles';
import { Translate } from 'react-redux-i18n';
import Utils from '../../utils';
import { Title, Subtitle, Option } from '../HeaderBlock/styles';

interface AccordionProps {
	title: string;
	isOpened: boolean;
	subtitle?: string;
	selectedOption?: string;
}

interface AccordionState {
	isOpened: boolean;
}

class Accordion extends React.Component<AccordionProps, AccordionState> {
	constructor(props: AccordionProps) {
		super(props);
		this.toggle = this.toggle.bind(this);
		this.state = { isOpened: props.isOpened };
	}

	public render() {
		const { title, subtitle, children, selectedOption } = this.props;
		const { isOpened } = this.state;

		return (
			<StyledAccordion className="Accordion">
				<AccordionHeader onClick={this.toggle}>
					<AccordionTitle>
						<Title><Translate value={title} /></Title>
						{subtitle &&
							<Subtitle>{subtitle}</Subtitle>
						}
						{selectedOption &&
							<Option><Translate value={selectedOption} /></Option>
						}
					</AccordionTitle>
					<ToggleButton isOpened={isOpened}>
						{Utils.getSvgIcon('iconset_down')}
					</ToggleButton>
				</AccordionHeader>
			{isOpened &&
				<div>{children} </div>
			}
		</StyledAccordion>
		);
	}

	private toggle(): void {
		this.setState({ isOpened: !this.state.isOpened });
	}
}

export default Accordion;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Accordion/index.tsx